import { http } from '../http'
import { URL } from './_constant'

/**
 * 国有土地项目-征拆户-列表
 */
export function API_GY_ZCH_LIST(data?: BasicPageReq) {
  return http.post<ApiGyZch.ListRes>(URL.LIST, data)
}

/**
 * 国有土地项目-征拆户-全部
 */
export function API_GY_ZCH_ALL(data?: BasicPageReq) {
  return http.post<ApiGyZch.Item[]>(URL.LIST, data)
}

/**
 * 国有土地项目-征拆户-简单列表
 */
export function API_GY_ZCH_SIMPLE_LIST(data?: BasicPageReq) {
  return http.post<BasicSimpleListItem[]>(URL.SIMPLE_LIST, data)
}

/**
 * 国有土地项目-征拆户-详情
 */
export function API_GY_ZCH_DETAIL(id: string) {
  return http.post<ApiGyZch.Item>(URL.DETAIL, { id })
}

/**
 * 国有土地项目-征拆户-新增
 */
export function API_GY_ZCH_ADD(data: ApiGyZch.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 国有土地项目-征拆户-删除
 */
export function API_GY_ZCH_DEL(data: ApiGyZch.DelReq) {
  return http.post(URL.DEL, data)
}

/**
 *  国有土地项目-征拆户-编辑
 */
export function API_GY_ZCH_EDIT(data: BasicUpdateOneReq<ApiGyZch.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  国有土地项目-征拆户-禁用
 */
export function API_GY_ZCH_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}

/**
 * 国有土地项目-征拆户-启用
 */
export function API_GY_ZCH_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 国有土地项目-征拆户-排序
 */
export function API_GY_ZCH_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}

/**
 * 国有土地项目-征拆户-其他信息设置
 */
export function API_GY_ZCH_OTHER_INFO_SET(data: BasicUpdateOneReq<ApiGyZch.OtherInfoData>) {
  return http.post(URL.OTHER_INFO_SET, data)
}

/**
 * 国有土地项目-征拆户-附件设置
 */
export function API_GY_ZCH_ATTACHMENTS_SET(data: BasicUpdateOneReq<ApiGyZch.AttachmentsData>) {
  return http.post(URL.ATTACHMENTS_SET, data)
}

/**
 * 国有土地项目-征拆户-审核列表
 */
export function API_GY_ZCH_REVIEW_LIST(data?: BasicPageReq) {
  return http.post<ApiGyZch.ListRes>(URL.REVIEW_LIST, data)
}

/**
 * 国有土地项目-征拆户-统计
 */
export function API_GY_ZCH_TONGJI(data: IdsPayload) {
  return http.post(URL.TONGJI, data)
}
